import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { SECRET_TABS, type SecretTab } from '@/features/access/access-tabs';
import { SecretDetailPage } from '@/features/access/secrets/secret-detail-page';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

export const Route = createFileRoute('/$tenant/secrets/$secretId')({
  validateSearch: (search: Record<string, unknown>): { tab: SecretTab } => ({
    tab: SECRET_TABS.parse(search['tab']),
  }),
  component: SecretRoute,
});

function SecretRoute() {
  const { tenant, secretId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="secrets"
      crumbs={[
        { label: t('access.secrets.title') },
        { label: <EntityName tenantId={tenant} kind="secret" id={secretId} /> },
      ]}
    >
      <SecretDetailPage
        tenantId={tenant}
        secretId={secretId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
